import styled from 'styled-components';

export const AuthContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(180deg, #f7f7fb 0%, #eef3ff 100%);
`;

export const AuthCard = styled.div`
  width: 100%;
  max-width: 440px;
  background: #31d5c830;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(28, 28, 51, 0.08);
  padding: 28px;

  @media (max-width: 480px) {
    padding: 20px;
  }
`;

export const AuthHeader = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

export const AuthTitle = styled.h1`
  margin: 0 0 6px 0;
  font-size: 24px;
  line-height: 32px;
  color: #1f2937;

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

export const AuthSubtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: #6b7280;
`;

export const AuthForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormLabel = styled.label`
  font-size: 13px;
  color: #374151;
  margin-bottom: 6px;
`;

export const FormInput = styled.input`
  width: 100%;
  height: 42px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    border-color: #30D5C8;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  }
`;

export const PasswordInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const PasswordInputField = styled(FormInput)`
  padding-right: 80px;
`;

export const TogglePasswordButton = styled.button`
  position: absolute;
  right: 8px;
  height: 30px;
  padding: 0 10px;
  border: none;
  background: #f3f4f6;
  color: #111827;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: #e5e7eb;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const FormActions = styled.div`
  margin-top: 6px;
`;

export const AuthButton = styled.button`
  width: 100%;
  height: 44px;
  background: #30D5C8;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s, transform 0.02s;

  &:hover {
    background: #189f94;
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const AuthFooter = styled.div`
  margin-top: 16px;
  text-align: center;
`;

export const AuthAlt = styled.p`
  font-size: 14px;
  color: #4b5563;
`;

export const AuthLink = styled.a`
  color: #30D5C8;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

export const NavLink = styled.a`
  text-decoration: none;
`;
